import { render, staticRenderFns } from "./AndamentoFamilia.vue?vue&type=template&id=79e00746&scoped=true"
import script from "./AndamentoFamilia.vue?vue&type=script&lang=js"
export * from "./AndamentoFamilia.vue?vue&type=script&lang=js"
import style0 from "./AndamentoFamilia.vue?vue&type=style&index=0&id=79e00746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e00746",
  null
  
)

export default component.exports